import { render, staticRenderFns } from "./product-dimension.vue?vue&type=template&id=5bd22a2f&"
import script from "./product-dimension.vue?vue&type=script&lang=js&"
export * from "./product-dimension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports